<template>
  <div>
    <div class="row">
      <div class="row page-title">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
        <div class="col-md-11">
          <h4><u>Παράμετροι εφαρμογής</u></h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex-container">
        <div class="row">
          <div class="col-md-4">
            <button
              class="invert"
              id="btnGlobalParams"
              v-if="isSuperAdmin"
              @click="showGlobalParams"
            >
              Γενικές παράμετροι
            </button>
            <button
              class="invert"
              id="btnAbsenseReasons"
              v-if="isSuperAdmin"
              @click="showAbsenceReasons"
            >
              Λόγοι Απουσίας
            </button>
          </div>

          <div class="col-md-4">
            <button
              class="invert"
              id="btnUnlockReasons"
              v-if="isSuperAdmin"
              @click="showUnlockReasons"
            >
              Λόγοι ξεκλειδώματος
            </button>
            <button
              class="invert"
              id="btnHolidays"
              v-if="isSuperAdmin"
              @click="showHolidays"
            >
              Αργίες
            </button>
            <button
              class="invert"
              id="btnActions"
              v-if="isSuperAdmin"
              @click="showActions"
            >
              Βήματα Πληρωμών
            </button>
          </div>

          <div class="col-md-4">
            <button
              class="invert"
              id="btnDocuments"
              v-if="isSuperAdmin"
              @click="showDocuments"
            >
              Δικαιολογητικά
            </button>
            <button
              class="invert"
              id="btnSecurityRules"
              v-if="isSuperAdmin"
              @click="showSecurityRules"
            >
              Κανόνες Ασφαλείας
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import BackButton from "../../components/shared/backButton";

export default {
  components: {
    BackButton,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  methods: {
    showApiLogs() {
      router.replace("/apiLogging");
    },
    showLoginLogs() {
      router.replace("/userLogging");
    },
    showAbsenceReasons() {
      router.replace("/absenceReasons");
    },
    showUnlockReasons() {
      router.replace("/unlockReasons");
    },
    showHolidays() {
      router.replace("/holidays");
    },
    showGlobalParams() {
      router.replace("/globalParams");
    },
    showDocuments() {
      router.replace("/documents");
    },
    showSecurityRules() {
      router.replace("/securityRules");
    },
    showActions() {
      router.replace("/actions");
    },
  },
};
</script>
